<template>
	<div>
		<div class="eb-content-default w75">
			
			<EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Contact</EbHeading>
			
			<EbBanner :isActive="isBannerActive" :type="bannerType" :timestamp="bannerTimestamp">{{ bannerContent }}</EbBanner>
			
			<section>
				<EbHeading level="h2" class="eb-box-heading">Maison départementale des solidarités</EbHeading>
				
				<EbLoader v-if="isLoading"></EbLoader>
				<address v-if="!isLoading && contactMDS">
					<div class="flex gap-5">
						<font-awesome-icon :icon="['fas', 'map-marker-alt']" />
						<abbr title="Maison départementale des solidarités">MDS</abbr> {{ contactMDS.libelle }}<br />
						{{ contactMDS.libelleAdresse }}<br />
						{{ contactMDS.codePostal }} {{ contactMDS.commune }}
					</div>
					<div class="flex gap-5">
						<font-awesome-icon :icon="['fas', 'phone']" />
						<a :title="getPhoneTitle('la MDS', contactMDS.numeroTelephone1)" :href="getPhoneLink(contactMDS.numeroTelephone1)">{{ contactMDS.numeroTelephone1 }}</a>
					</div>
					<div class="flex gap-5">
						<font-awesome-icon :icon="['fas', 'phone']" />
						<a v-if="contactMDS.numeroTelephone2" :title="getPhoneTitle('la MDS', contactMDS.numeroTelephone2)" :href="getPhoneLink(contactMDS.numeroTelephone2)">
							{{ contactMDS.numeroTelephone2 }}
						</a>
					</div>
					<a :href="getMailLink(contactMDS.courrielPmi)" :title="getMailTitle(contactMDS.courrielPmi)" target="_blank" rel="noreferrer noopener" class="flex gap-5 align-items">
						<font-awesome-icon :icon="['fas', 'envelope']" />{{ contactMDS.courrielPmi }}
					</a>
				</address>
				<p v-if="!isLoading && !contactMDS">Aucune information de rattachement à une MDS ne correspond à votre profil.</p>
				
			</section>
			
			<section>
				<EbHeading level="h2" class="eb-box-heading">Formulaire de contact</EbHeading>
				
				<p class="text-italic">
					Contactez la Maison départementale des solidarités de votre secteur, votre message lui sera directement envoyé :
				</p>
				
				<form action="#" @submit.prevent="sendMessage">
					<EbInput v-model="objet" required label="Objet de ma demande :" width="expand"></EbInput>
					
					<EbTextarea label="Mon message :" :rows="10" v-model="message" required width="expand"></EbTextarea>
					<EbButton type="submit">Envoyer mon message</EbButton>
				</form>
			</section>
		</div>
	</div>
	
</template>

<script>
export default {
	name: "contact",
	data() {
		return {
			objet: '',
			message: '',
			contactMDS: null,
			
			isLoading: true,
			
			isBannerActive: false,
			bannerTimestamp: '',
			bannerType: null,
			bannerContent: ''
		}
	},
	mounted() {
		this.getRattachements()
	},
	methods: {
		getRattachements: async function() {
			this.bannerTimestamp = this.getTime()
			
			await this.$http
			.get("partenaire/contact")
			.then(resp => {
				this.isLoading = false
				this.contactMDS = resp.data.mds
			})
			.catch(error => {			
				this.isLoading = false
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue lors de la récupération des informations la Maison départementale des solidarités, veuillez réessayer ultérieurement.'
			})			
			
		},
		sendMessage: async function() {
			this.isBannerActive = true
			this.bannerTimestamp = this.getTime()
			
			await this.$http
			.post("partenaire/contact", {
				objet: this.objet,
				message: this.message
			})
			.then(resp => {
				this.bannerType = 'success'
				this.bannerContent = 'Votre message a été envoyé avec succès.'
				
				this.objet = ''
				this.message = ''
			})
			.catch(error => {
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue lors de l’envoi de votre message, veuillez réessayer ultérieurement.'
			})
		}
	},
}
</script>
